import { requestGet } from '../utils/request';
import { getUserMockFile } from '../utils/mocks';

const BASE_URL = '/api/user/v2/details';

/**
 * Get User by id
 * @param {String} userId
 * @param {Boolean} isProxying = false
 * @return {Promise} Response
 */
export function requestUserDetails(userId, isProxying = false) {
  return requestGet(`${BASE_URL}?userId=${userId}`, {
    mockFile: `user/${getUserMockFile(undefined, isProxying)}`,
    headers: {
      'x-user-id': userId,
    },
  });
}
